var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlms2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 512,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 1707 1707",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1288 1102h-113-139-113-140-112-140-112-137c-13 0-23-10-23-23s10-23 23-23h114v-271c0-13 10-23 23-23h112c13 0 23 10 23 23v271h94v-354c0-13 10-23 23-23h112c13 0 23 10 23 23v354h94v-461c0-13 11-23 23-23h113c12 0 22 10 22 23v461h95v-599c0-12 10-23 22-23h113c13 0 23 11 23 23v599h114c12 0 23 10 23 23s-11 23-23 23zm313 92h-542c-30 35-46 79-46 126 0 36 10 72 29 103h248c13 0 23 10 23 22v136c0 12-10 23-23 23h-874c-12 0-22-11-22-23v-136c0-12 10-22 22-22h249c19-31 29-67 29-103 0-47-16-91-46-126h-542c-58 0-106-48-106-106v-879c0-58 48-106 106-106h1495c58 0 106 48 106 106v879c0 58-48 106-106 106zm-598 0h-299c23 37 35 80 35 126 0 36-7 71-23 103h274c-15-32-23-67-23-103 0-46 13-89 36-126zm-897-1046c-33 0-61 28-61 61v879c0 33 28 60 61 60h1495c33 0 60-27 60-60v-879c0-33-27-61-60-61zm333 1410h828v-90h-237-353-1-237zm2-502h68v-248h-68zm253 0h67v-332h-67zm252 0h67v-439h-67zm252 0h67v-576h-67zm-541-436c-117 0-212-95-212-212s95-213 212-213 213 96 213 213-96 212-213 212zm-22-378c-74 10-133 69-143 143h24c12 0 22 10 22 23 0 12-10 22-22 22h-24c10 74 69 133 143 143v-24c0-12 10-22 22-22 13 0 23 10 23 22v24c74-10 133-69 143-143h-24c-12 0-23-10-23-22 0-13 11-23 23-23h24c-10-74-69-133-143-143v24c0 12-10 23-23 23-12 0-22-11-22-23zm23 188h-38c-13 0-23-10-23-22 0-13 10-23 23-23h16v-42c0-13 10-23 22-23 13 0 23 10 23 23v65c0 12-10 22-23 22z",
    fill: "#666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlms2);
export default __webpack_public_path__ + "static/media/plms2.5ba8cb464b0bdd2c46553a8aeb42ecdf.svg";
export { ForwardRef as ReactComponent };